export const FIELD_NAMES = {
  VENDOR_FACING_COMPANY_NAME: 'vendorFacingCompanyName',
  VENDOR_NICKNAME: 'vendorNickname',
  EMAIL_ADDRESS: 'emailAddress',
};

export const INVITE_REQUEST_VALUES = {
  CLIENT_TO_PARTNER: 'ClientToPartner',
  PARTNER_TO_CLIENT: 'PartnerToClient',
  MARKETPLACE_VENDOR: 'marketplace_vendor',
  CLIENT_3PL: 'client_3pl',
};
